import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { GetNewsAndEventsDetailApi } from '../redux/actions/NewsAndEvents/DetailAction';
import { useDispatch, useSelector } from 'react-redux';
import { PuffLoader, PulseLoader } from 'react-spinners';
import backend_url from '../services/endpoints';

const NewsAndEventsDetail = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const { response, loading, error } = useSelector((state) => state.newsAndEventsDetail);

    useEffect(() => {
        dispatch(GetNewsAndEventsDetailApi(id));
    }, [id])

    return (
        <>
            {
                loading ? (
                    <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center text-center' >
                        <PulseLoader size={85} color="#0f0a30" />
                    </div >
                ) :
                    error ?
                        (
                            <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
                                <p className='text-danger'>Something went wrong</p>
                            </div>
                        ) :
                        (
                            <section className='main'>
                                <div className='container'>
                                    <div className='row gy-4'>
                                        <div className='col-12'>
                                            <div className="wrapper-card">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className='hstack flex-wrap gap-3'>
                                                            <div className='supp_img'>
                                                                <img src={response?.data[0]?.image ? `${backend_url}${response?.data[0]?.image}` : '/assets/images/user.png'} alt="new&events" />
                                                            </div>
                                                            <div className="info_content">
                                                                <div className='supplier_name_blk mb-3'>
                                                                    <h3 className='fw-bold mb-0'>{response?.data[0]?.title || 'N/A'}</h3>
                                                                </div>
                                                                <div className="info_content-row hstack flex-wrap">
                                                                    <div className="info-detail">
                                                                        <h2 className="h4">Commnets</h2>
                                                                        <p className="mb-0">{response?.data[0]?.commentAdded || 0}</p>
                                                                    </div>
                                                                    <div className="info-detail">
                                                                        <h2 className="h4">Rsvp</h2>
                                                                        <p className="mb-0">{response?.data[0]?.rsvpAdded || 0}</p>
                                                                    </div>
                                                                    <div className="info-detail">
                                                                        <h2 className="h4">Description</h2>
                                                                        <p className="mb-0">{response?.data[0]?.description || 'N/A'}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12'>
                                            <div className='common_tabs'>
                                                <nav>
                                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                        <button className="nav-link active" id="nav-cmt-1-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-1" type="button" role="tab" aria-controls="nav-cmt-1" aria-selected="true">Comments</button>
                                                        <button className="nav-link" id="nav-cmt-2-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-2" type="button" role="tab" aria-controls="nav-cmt-2" aria-selected="false">Joining Users</button>
                                                    </div>
                                                </nav>
                                                <div className="tab-content wrapper-card" id="nav-tabContent">
                                                    <div className="tab-pane fade show active" id="nav-cmt-1" role="tabpanel" aria-labelledby="nav-cmt-1-tab" tabIndex={0}>

                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}>
                                                            <PuffLoader color="#94d23d" size={120} />
                                                            <p style={{
                                                                marginTop: '20px',
                                                                color: '#94d23d',
                                                                fontWeight: 'bold',
                                                                fontSize: '30px',
                                                                textAlign: 'center'
                                                            }}>
                                                                Under Development
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div className="tab-pane fade" id="nav-cmt-2" role="tabpanel" aria-labelledby="nav-cmt-2-tab" tabIndex={0}>

                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}>
                                                            <PuffLoader color="#94d23d" size={120} />
                                                            <p style={{
                                                                marginTop: '20px',
                                                                color: '#94d23d',
                                                                fontWeight: 'bold',
                                                                fontSize: '30px',
                                                                textAlign: 'center'
                                                            }}>
                                                                Under Development
                                                            </p>
                                                        </div>

                                                    </div>


                                                    <div className="tab-pane fade" id="nav-cmt-4" role="tabpanel" aria-labelledby="nav-cmt-4-tab" tabIndex={0}>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div >
                            </section >
                        )
            }
        </>
    )
}

export default NewsAndEventsDetail